// Core
import React from 'react';

// Components
import {
    GeckoCardBody,
    GeckoCardHeader,
    GeckoCardWrapper,
} from '@geckolabs/gecko-react-ui';

import Line from './Line';

// Styles
import './StatCard.css';

export const STAT_TYPE_LINE = 'line';

const CHART_RENDERERS = {
    [STAT_TYPE_LINE]: Line,
};

const StatCard = ({
    name,
    icon,
    headerChildren = null,
    type = STAT_TYPE_LINE,
    data = [],
    chartProps = {},
    summary = null,
    error = null,
    emptyMessage = 'No data for the selected filters.',
    className = '',
}) => {
    const renderSummary = () => {
        if (!summary || !summary.length) {
            return null;
        }

        return (
            <div className="statCard-summary">
                {summary.map(({ label, value, color }) => (
                    <div key={label} className="statCard-summary-item">
                        <div className="statCard-summary-value">{value}</div>
                        <div className="statCard-summary-label">
                            {color ? (
                                <span
                                    className="statCard-summary-swatch"
                                    style={{ backgroundColor: color }}
                                />
                            ) : null}
                            {label}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const renderChart = () => {
        if (error) {
            return <div className="alert alert-warning mb-0">{error}</div>;
        }

        if (!data.length) {
            return <p className="statCard-empty mb-0">{emptyMessage}</p>;
        }

        const Chart = CHART_RENDERERS[type];

        return <Chart data={data} chartProps={chartProps} />;
    };

    return (
        <GeckoCardWrapper className={`statCard ${className}`.trim()}>
            <GeckoCardHeader name={name} icon={icon}>
                {headerChildren}
            </GeckoCardHeader>
            <GeckoCardBody padded>
                {renderSummary()}
                {renderChart()}
            </GeckoCardBody>
        </GeckoCardWrapper>
    );
};

export default StatCard;
